import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SanctionlogsComponent } from './sanctionlogs/sanctionlogs.component';
import { TabViewModule, DataTableModule, AccordionModule } from 'primeng/primeng';
import { IsiReportDetailComponent } from './isi-report-detail/isi-report-detail.component';
import { DisplayClientReportComponent } from './display-client-report/display-client-report.component';
import { MaterialModule } from '@angular/material';
import { AppRoutingModule } from 'app/app-routing.module';
import { DisplayPersonReportComponent } from './display-person-report/display-person-report.component';
import { CountryWisePersonComponent } from './country-wise-person/country-wise-person.component';
import { CountryWiseEntityComponent } from './country-wise-entity/country-wise-entity.component';
import { StructureWiseEntityComponent } from './structure-wise-entity/structure-wise-entity.component';
import { IsiReportDetailTwoComponent } from './isi-report-detail-two/isi-report-detail-two.component';
import {IsiReportDetailSubofficesComponent} from './isi-report-detail-suboffices/isi-report-detail-suboffices.component';

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    TabViewModule,
    MaterialModule,
    AppRoutingModule,
    AccordionModule

  ],
  declarations: [
    SanctionlogsComponent,
    IsiReportDetailComponent,
    DisplayClientReportComponent,
    DisplayPersonReportComponent,
    CountryWisePersonComponent,
    CountryWiseEntityComponent,
    StructureWiseEntityComponent,
    IsiReportDetailTwoComponent,
    IsiReportDetailSubofficesComponent
  ]
})

/**
 * Main module for the Reporting module, applicable for Sanction Logs as of now.
*/
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts